import React from 'react';
import Box from '@material-ui/core/Box';
export const Company = ({ intl }) => (React.createElement(Box, { component: 'div', sx: {
        background: '#F4F6F8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: { xs: '16px 10px', sm: '30px 10px' }
    } },
    React.createElement(Box, { component: 'div', sx: {
            width: '100%',
            color: '#434242',
            fontSize: '12px',
            marginBottom: 0,
            paddingBottom: 0,
            textAlign: 'center',
            fontFamily: 'Poppins-Regular'
        } }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
        id: 'copyright',
        defaultMessage: 'DESIGNS.AI by Pixlr {year}. © All rights reserved '
    }, { year: new Date().getFullYear() }))));
//# sourceMappingURL=Company.js.map